import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import AdminApp from '@/admin/AdminApp'
import { RoleGuard } from '@portals/shared/guards/RoleGuard'
import { PortalLoginPage } from '@portals/shared/components/PortalLoginPage'
import { ToastProvider } from '@/components/feedback/ToastProvider'

export function AdminPortal() {
  const renderAdminLogin = () => (
    <PortalLoginPage
      portal="admin"
      title="Executive Admin Sign In"
      description={[
        'Access platform-wide configuration, compliance audit trails, and finance exports.',
        'Super admin credentials are required to continue.'
      ]}
      scope="admin"
      requestedScopes={[]}
      redirectPath="/"
      allowedRoles={['SUPER_ADMIN', 'ADMIN']}
    />
  )

  return (
    <Router>
      <ToastProvider>
        <Routes>
          <Route
            path="/login"
            element={renderAdminLogin()}
          />
          <Route
            path="/*"
            element={
              <RoleGuard
                portal="admin"
                allowedRoles={['SUPER_ADMIN', 'ADMIN']}
                requiredScopes={['admin:super']}
                fallback={renderAdminLogin()}
              >
                <AdminApp />
              </RoleGuard>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </ToastProvider>
    </Router>
  )
}
